export const SUCCESSFUL_CREATION_CONTENT = "Custom NFT Wall created!";

export const UNABLE_TO_ACCESS_CONTENT = "We couldn't access some of your art!";

export const INVALID_WALLET_ADDRESS = 'Must be a valid ETH address'